import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import bankingService from "api/bankingService";
import { IFinancialOperation } from "dto/Banking/IBanking";

interface Props {
  operation: IFinancialOperation;
  onClose: () => void;
}

/** Modal dodawania / edycji notatki do operacji finansowej. */
const NoteModal = ({ operation, onClose }: Props) => {
  const save = bankingService.useSaveNote();
  const [note, setNote] = useState(operation.Note ?? "");

  const handleSave = () => {
    save.mutate({ operationId: operation.Id, note }, { onSuccess: () => onClose() });
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Dodaj notatkę</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          size="small"
          margin="dense"
          label="Notatka do operacji"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Wpisz notatkę…"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Anuluj</Button>
        <Button variant="contained" onClick={handleSave} disabled={save.isLoading}>
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoteModal;
